// extracted by mini-css-extract-plugin
export default {"form":"ConfigModal_form__5Wqut","textarea":"ConfigModal_textarea__Mlijv"};